import {
  withImageEmbed,
  getWithSelectionCaption,
  ELEMENT_IMAGE,
} from '@udecode/plate';

import { withImageUpload } from '../upload/withImageUpload';

export const withImage = (
  editor,
  plugin,
) => {
  let _editor = editor;
  const {
    options: { disableUploadInsert, disableEmbedInsert, disableCaption },
  } = plugin;
  if (!disableUploadInsert) {
    _editor = withImageUpload(editor, plugin);
  }

  if (!disableEmbedInsert) {
    _editor = withImageEmbed(editor, plugin);
  }

  if (!disableCaption) {
    _editor = getWithSelectionCaption(ELEMENT_IMAGE)(editor, plugin);
  }

  return _editor;
};